import { useEffect, useState } from "react";
import { useNavigate , Link } from "react-router-dom";
import SearchBar from "../../common/components/SearchBar";
import { Button } from "../../common/Button";
import { EditClinicLocation } from "./Edit";
import { useSelector } from "react-redux";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import { getLocationQuery } from "../../api/ClinicLocation";
import { FullPageSpinner } from "../../common/Spinner/FullPageSpinner";
import EditIcon from "../../../assets/images/edit.png";
import { Skeleton, TableCell, Tooltip } from "@mui/material";
import Table from "react-bootstrap/Table";
import CrossIcon from "../../../assets/images/Cross1.svg";
import RightIcon from "../../../assets/images/Tick1.svg";
import InformationIcon from "../../../assets/images/information1.svg";
import CustomPagination from "../../common/components/Pagination/CustomPagination";
import {categoryType} from "./Constants"
import SearchSelect from "../../common/textfield/SearchSelect";
import { failed } from "../../common/Toastify";

function ClinicLocationList() {
    const navigate = useNavigate();
    const [modalShow, setModalShow] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [locations, setLocations] = useState([]);
    const [loadingLocationData, setLoadingLocationData ] = useState(false)
    const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
    const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const totalRows = filterData.length;
    const [organizations, setOrganizations] = useState([]);
    const [orgId, setOrgId] = useState(userRoles?.includes("Super-Admin") ? null : adminOrgs?.[0]?.id);
    
    useOrgQuery({
        onSuccess: (data) => {
            setOrganizations(data?.map((org) => ({ label: org?.name, value: org?.id }))) 
        },
        refetchOnWindowFocus: false,
    })
     
    const handleShow = (data) => { setModalShow(modalShow ? false : data) };
    const handleFilterData = (data) => { 
        setFilterData(data)
    }
    const handleOrgChange = (selectedOption) => {
        setOrgId(selectedOption?.value);
    }

    const getLocationsList = async () => {
        setLoadingLocationData(true);
        try {
            let list = await getLocationQuery({organizationIds: [orgId], userRoles})
            if(list?.status) {
                const sortedData = [...(list?.data || [])].sort((a, b) =>
                (a?.name || '').localeCompare(b?.name || '')
            );
                setLocations(sortedData);
                setFilterData(sortedData);
            }
            else {
                setLocations([]);
                setFilterData([]);
            }
        }
        catch(error) {
            console.error('Error fetching report deliveries list:', error);
            failed(error.message)     
        }
        finally {
            setLoadingLocationData(false);
        }
    }

    useEffect(() => {
        if (orgId) {
            getLocationsList(orgId)
        }
    }, [orgId])

    let addressData;
    let cityData;
    let faxData;
    let sftData;
    let categoryTypeCodeData;

    const getCategoryValuesString = (codes = []) => {
        return categoryType
            .filter(item => codes && Array.isArray(codes) && codes.includes(item.code))
            .map(item => item.name)  
            .join(", ");
    };

    const sortObjArray = (obj) => {
        let sorted = obj?.sort((a, b) =>  a?.label?.toLowerCase() > b?.label?.toLowerCase() ? 1 : -1);
        return sorted || []
    }

    const selectedOrgOption =
        orgId == null
            ? null
            : organizations.find((o) => String(o.value) === String(orgId)) ?? null;

    return (
        <section className="common-listing">
            {loadingLocationData && <FullPageSpinner loadingText="Loading Locations" />}
            <EditClinicLocation
                modalShow={modalShow}
                refreshTable={getLocationsList}
                handleShow={handleShow}
            />
            <div className="heading-wrap h-change">
                {organizations.length > 1 &&                
                    <div style={{ width: 400, marginRight: "20px"}}>
                        <SearchSelect
                            keyField={"organization"}
                            label={"Select Organization"}
                            placeholder="Select Organization..."
                            options={sortObjArray(organizations)}
                            value={selectedOrgOption}
                            isLoading={organizations?.length > 1 ? false : true}
                            isDisabled={organizations?.length > 1 ? false : true}
                            hideRequired={true}
                            onChange={handleOrgChange}
                            labelStyle={{ marginBottom: 0 }}
                        />                        
                    </div>
                }
                <SearchBar page={page} setPage={setPage} list={locations} filterData={handleFilterData} />
                 
                <div className="right-wrap" style={{ margin: 'left' }}>
                    <Button onClick={() => navigate("/app/add-clinic-location")} className="custom-btn" title="Add Location" style={{ width: 'auto' }}> + Create Location</Button>
                </div> 
            </div>        
        
            <div className="table-wrap">
                    <Table responsive>
                        <thead>
                            <tr>                                
                                <th>Name</th>
                                <th>Type</th>
                                <th>Address</th>
                                <th>Organization</th>
                                <th>Fax</th>
                                <th>SFT</th>
                                <th style={{ textAlign: "center", width: "1%", whiteSpace: "nowrap" }}>Description</th>
                                <th style={{ textAlign: "center" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            { 1 === 2 ? (
                                [1, 2, 3, 4, 5, 6, 7, 8]?.map((val) => (
                                    <tr key={val}>
                                         <td>
                                            <Skeleton animation="wave" />
                                        </td>
                                        <td>
                                            <Skeleton animation="wave" />
                                        </td> 
                                        <td>
                                            <Skeleton animation="wave" />
                                        </td>
                                        <td>
                                            <Skeleton animation="wave" />
                                        </td>
                                        <td>
                                            <Skeleton animation="wave" />
                                        </td>
                                        <td>
                                            <Skeleton animation="wave" />
                                        </td>
                                        <td>
                                            <Skeleton animation="wave" />
                                        </td>
                                        <td>
                                            <Skeleton animation="wave" />
                                        </td>
                                    </tr>
                                ))
                            ) : filterData?.length > 0 ? (
                                filterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data) => {                                  

                                    data.address[0]?.city == undefined ? cityData = "" : cityData = data.address[0]?.city ;
                                    addressData = data.address[0]?.line[0] +','+ cityData  +' '+ data.address[0]?.state  +' '+ data.address[0]?.postalCode ;                                
                                    faxData = data.telecom[2]?.value === undefined ? "-" : data.telecom[2]?.value;
                                    sftData = data.sftEnabled === true ? <img src={RightIcon} alt="" />  : <img src={CrossIcon} alt="" /> ;
                                    categoryTypeCodeData =  getCategoryValuesString(data?.categoryTypeCode); 
                                    return (
                                        <tr key={data?.id}>
                                            <td>{data?.name?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</td>
                                            <td>{categoryTypeCodeData || data.type[0]?.coding[0]?.display || "-"}</td>
                                            <td>{addressData}</td>
                                            <td>{data?.managingOrganization?.display}</td>
                                            <td>{faxData}</td>
                                             <td>{sftData }</td>
                                             <td style={{ textAlign: "center", width: "1%", whiteSpace: "nowrap" }}>
                                                <Tooltip title={data?.description}>
                                                    <img src={InformationIcon} alt="" style={{ verticalAlign: "middle" }} />
                                                </Tooltip>
                                            </td>
                                           
                                            <td>
                                                <div className="action-wrap">
                                                    <Tooltip title={"Edit"}>
                                                            <Link to="" variant="primary" onClick={() => handleShow(data, false)} className="success-btn">
                                                                <img src={EditIcon} alt="Edit" />
                                                            </Link>
                                                        </Tooltip>                                                   
                                                    
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <TableCell colSpan="5" style={{ textAlign: "center" }}>
                                        No Data Available
                                    </TableCell>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>

                {filterData?.length > 0 ? <CustomPagination tableData={filterData} totalRows={totalRows} rowsPerPage={rowsPerPage} page={page} handlePage={(pageNo) => setPage(pageNo)} /> : null}

        </section >
    );
}

export default ClinicLocationList;